import { createSlice } from '@reduxjs/toolkit';

interface PlaidTriggerState {
  plaidTrigger: boolean;
}

const initialState: PlaidTriggerState = {
  plaidTrigger: false,
};

const plaidTriggerSlice = createSlice({
  name: 'plaidTrigger',
  initialState,
  reducers: {
    setPlaidTrigger(state, action) {
      console.log({action})
      state.plaidTrigger = action.payload.plaidTrigger;
    },
  },
});

export const { setPlaidTrigger } = plaidTriggerSlice.actions;

export default plaidTriggerSlice.reducer;
